// A table's sort as the person last set it (column + direction, several too): applied when they open
// or refresh the page; "Back to priority order" ([]) is the default. Kept in this browser, as Columns
// and Source are — OUTSIDE-PLATFORM: P20, the platform's user store has no kind for an app's
// preferences; with one, the three move to the server and follow the person. A person's saved
// default (`my-default.tsx`) is on the server already, and its sort wins over this one.

import type { SortingState } from "@tanstack/react-table";

const key = (table: string) => `routing.sort.${table}`;

/** A sort as text (this browser's, or a saved default's): only well-formed entries; anything else is the default. */
export function parseSort(text: string | null | undefined): SortingState {
  try {
    const v: unknown = JSON.parse(text || "[]");
    return Array.isArray(v)
      ? v.flatMap((s: unknown) => {
          const x = s as { id?: unknown; desc?: unknown };
          return typeof x?.id === "string" && typeof x.desc === "boolean" ? [{ id: x.id, desc: x.desc }] : [];
        })
      : [];
  } catch {
    return [];
  }
}

/** The sort kept for `table` in this browser. */
export function readSort(table: string): SortingState {
  try {
    return parseSort(localStorage.getItem(key(table)));
  } catch {
    return [];
  }
}

/** A sort as text, as kept. */
export const sortText = (sorting: SortingState) => JSON.stringify(sorting.map(({ id, desc }) => ({ id, desc })));

export function writeSort(table: string, sorting: SortingState) {
  try {
    if (sorting.length) localStorage.setItem(key(table), sortText(sorting));
    else localStorage.removeItem(key(table));
  } catch {
    // Private window: kept for this page only.
  }
}
